// Phase 25 iter-7 — "Esqueciches o contrasinal?" form.

import { ArrowLeft, Mail } from 'lucide-react';
import { useState } from 'react';
import type { FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { describeAxiosError } from '../api/errors';
import { requestPasswordReset } from '../api/passwordReset';
import Spinner from '../components/ui/Spinner';

export default function ForgotPasswordPage(): JSX.Element {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!email.trim()) {
      setError('Introduce un email.');
      return;
    }
    setError(null);
    setLoading(true);
    try {
      await requestPasswordReset({ email: email.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err) {
      setError(describeAxiosError(err, 'Non se puido enviar o correo.'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="min-h-[60vh] flex items-center justify-center px-6 py-12 bg-subtle">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-card-hover p-8">
        <Link
          to="/marketplace/login"
          className="inline-flex items-center gap-1 text-sm text-muted hover:text-dark mb-4"
        >
          <ArrowLeft size={14} />
          Volver
        </Link>
        <h1 className="text-2xl font-bold text-dark mb-2">Esqueciches o contrasinal?</h1>
        {submitted ? (
          <p className="text-sm text-muted leading-relaxed">
            Se o teu email está rexistrado, enviámosche un correo cun enlace para crear un novo
            contrasinal. Caduca en 1 hora. Revisa tamén o cartafol de spam.
          </p>
        ) : (
          <>
            <p className="text-sm text-muted leading-relaxed mb-5">
              Introduce o email da túa conta. Enviarémosche un enlace para crear un novo
              contrasinal.
            </p>
            <form onSubmit={handleSubmit} noValidate className="space-y-4">
              <div className="relative flex items-center border border-border rounded-xl px-4 py-3">
                <Mail size={16} className="text-muted shrink-0 mr-3" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="o.teu.email@exemplo.gal"
                  autoComplete="email"
                  className="flex-1 outline-none text-sm text-dark placeholder-muted bg-transparent"
                  autoFocus
                />
              </div>
              {error && <p className="text-sm text-rauxa">{error}</p>}
              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full py-3 disabled:opacity-60"
              >
                {loading ? <Spinner size={18} className="mx-auto" /> : 'Enviar enlace'}
              </button>
            </form>
          </>
        )}
      </div>
    </main>
  );
}
